import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-toolbar" }
const _hoisted_3 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2" }
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-5" }
const _hoisted_8 = { class: "symbol symbol-50px me-2" }
const _hoisted_9 = { class: "symbol-label" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_12 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_13 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_14 = { class: "d-flex flex-stack mb-2" }
const _hoisted_15 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_16 = { class: "progress h-6px w-100" }
const _hoisted_17 = ["aria-valuenow"]
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
}
const _hoisted_20 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
        _createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tasks Overview"),
        _createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "Pending 10 tasks")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/general/gen024.svg",
              "aria-hidden": "true"
            })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "p-0 w-50px" }),
              _createElementVNode("th", { class: "p-0 min-w-200px" }),
              _createElementVNode("th", { class: "p-0 min-w-100px" }),
              _createElementVNode("th", { class: "p-0 min-w-40px" })
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("img", {
                        src: item.image,
                        class: "h-50 align-self-center",
                        alt: ""
                      }, null, 8, _hoisted_10)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(item.info.title), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.info.description), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.progress.value) + "% ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`
                          progress-bar
                          bg-${item.progress.color}
                        `),
                        role: "progressbar",
                        style: _normalizeStyle(`width: ${item.progress.value}%`),
                        "aria-valuenow": item.progress.value,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 14, _hoisted_17)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("a", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, {
                        src: "/media/icons/duotune/arrows/arr064.svg",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}